// Module
var code = "<div class=\"read-more\"> {{vm.displayText}} <div class=\"link\" ng-if=\"vm.hasReadMore\"> <a href=\"#\" ng-click=\"vm.handleClick($event)\">{{vm.label}}</a> </div> </div> ";
// Exports
module.exports = code;